import { render } from "./saveCommodite.vue?vue&type=template&id=74fba734&scoped=true"
import script from "./saveCommodite.vue?vue&type=script&lang=js"
export * from "./saveCommodite.vue?vue&type=script&lang=js"

import "./saveCommodite.vue?vue&type=style&index=0&id=74fba734&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74fba734"]])

export default __exports__